import { render } from "./link-button.vue?vue&type=template&id=cfc62f0c&lang=pug"
import script from "./link-button.vue?vue&type=script&lang=js"
export * from "./link-button.vue?vue&type=script&lang=js"
script.render = render

export default script